import React, { useState, useEffect } from "react";
import { ActionsUser } from "../../style";
import recorridoIcon from "static/assets/images/icons/360Icon.svg";
import planosIcon from "static/assets/images/icons/planoIcon.svg";

const ActionsUsers = (props) => {
  const [img360, setImg360] = useState("");
  const [planos, setPlanos] = useState("");

  useEffect(() => {
    setImg360(props.img360);
    setPlanos(props.blueprints);
  }, [
    props.img360,
    props.blueprints,
  ]);

  return (
    <ActionsUser>
      {img360 && (
        <a
          className="default-button recorrido"
          href={img360}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={recorridoIcon} alt="recorrido" />
        </a>
      )}
      {planos.length > 0 && (
        <div
          className="default-button planos"
          onClick={props.onClickBluePrints}
        >
          Planos
          <img src={planosIcon} className="plano" alt="planos" />
        </div>
      )}
      {(img360 || planos.length > 0) && <div className="separator"></div>}
    </ActionsUser>
  );
};

export default ActionsUsers;
